import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type OrderConfirmation } from "../OrderConfirmation/types";
import { type OrderDetail } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    args: OrderDetail.Api.InitRequest
  ): Promise<HttpApiResponse<OrderDetail.Api.InitResponse>> =>
    api.get(apiInfo, "/api/site/v1/modules/orderDetail", args),
  downloadInvoice: (apiInfo: ModuleApiInfo, args: OrderConfirmation.Api.DownloadInvoiceRequest): Promise<void> =>
    api.download(apiInfo, `/api/site/v1/modules/orderConfirmation/invoice`, args),
  createComment: (
    apiInfo: ModuleApiInfo,
    id: string,
    comment: string
  ): Promise<HttpApiResponse<OrderConfirmation.Api.CreateCommentResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/orderConfirmation/${id}/comment`, { comment })
};
